import { render } from "./EditBadgesTable.vue?vue&type=template&id=974411c8&scoped=true"
const script = {}

import "./EditBadgesTable.vue?vue&type=style&index=0&id=974411c8&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-974411c8"]])

export default __exports__